var listeFiltresRapport = {
    parametres: {
        "colonneTri": "type"
    },
    champs: {}
};


$(function () {
    masquesSelection.init();
});

// générique pour être utilisable par responsable_execution également

function chargerFiltresEtDonnees(tableElem, init) {
    var filtres = tableElem.data('filtres');

    var tableFiltres = tableElem.data('table-filtres');
    var callback = fct_filtre_appliquer_callback_rapport(tableElem);

    // TODO Insérer un processus de validation de base des filtres (pas de qwqee dans les dates, etc...)
    reqTagsFiltresRecherche(filtres, tableFiltres, callback, init); // Charger la liste des champs requis pour populer les listes des filtres.

    var fct_importer_data = tableElem.data('fct-importer-data');
    var detruireTable = (init ? false : true);
    fct_importer_data(detruireTable);
    $('[name="valeur_batiment"]').on("keyup", function(e) {
        // Annule s'il y a une sélection
        var selection = window.getSelection().toString();
        if (selection !== '')
            return;
        // Annule s'il s'agit de flèche
        if ([38, 40, 37, 39].includes(e.keyCode))
            return;
        if (this.value) {
            var input = this.value.replace(/\D+/g, "");
            input = input ? parseInt(input, 10) : 0;
            // toLocaleString met des nbsp, on les remplace pour des espaces
            this.value = input.toLocaleString("fr-CA").replaceAll(String.fromCharCode(160), ' ');
        }
    });

}

function reqTagsFiltresRecherche(listeFiltres, tableFiltres, callback, init) {
    if (init) {
        var champsDynamiques = dessineTagsFiltresRecherche(listeFiltres, tableFiltres, callback);
        chargerTagsFiltresRecherche(tableFiltres, champsDynamiques);
    }

}


function dessineTagsFiltresRecherche(listeFiltres, tableFiltres, callback_filtre_appliquer) {
    var listeEvenements = listeFiltres.champs;
    var parametres = [];

    $.each(listeEvenements, function (key, value) {
        var formType = value.parametres[0].form;
        switch (formType) {
            case "select":
                parametres.push({"nom": key, "taille": value.parametres[0].taille});
                break;
            case "button":
                parametres.push({"nom": key, "taille": value.parametres[0].taille});
                break;
        }
    });

    dessineBoutonsActionFiltresRecherche(tableFiltres, callback_filtre_appliquer);
    return parametres;

}

function initialiserBoutonFiltre(listeFiltres, tableFiltres, a) {
    var selection = a.target.value; // Donnée avec chemin pour m_listeFiltres
    if (selection == "") {
        return;
    }

    var nomChamp = $(a.target).attr('name');

    var selectionText = $(a.target).children(":selected").text(); // Contenu du champs sélectionné. Pour les dates, voir la fonction déclencheur ".on('apply.daterangepicker',"
    //var resultat = regEx.decomposeIdFiltre(selection, '-');
    var titre = regEx.decomposeNomSelectFiltre(selectionText);
    var etat = "Actif";
    ajouteSousFiltreRecherche(listeFiltres, tableFiltres, nomChamp, selection, titre, etat);
    a.target.options.selectedIndex = 0;
    // On doit forcer le rafraichissement de Select2 sinon on voit toujours l'option choisie même si la liste derrière a été mise à jour !
    $(a.target).select2("val", "");
}


function modaleEnregistrerPreferencesFiltresRapport(tableFiltres){
    var tableElem = tableFiltres.data('table-elem');
    let id_rapport = tableElem.data('id-rapport');
    let paramsModals = {
        id: 'modale-enregistrer-preferences-filtres-rapport',
        titre:'Enregistrer vos préférences filtres rapports',
        view: "/core/modal/",
        template_view: "/gestion-roles/modale-enregistrer-preferences-filtres-rapport/",
        taille: "grande"
    };
    let customParams = {
        rapport_id: id_rapport,
        id_evenement_type: ''
    };
    var callback_modaleEnregistrerPreferencesFiltresRapport = function(){
        $('#button-meme-preferences-filtres-rapport').on('click', function(e){
            enregistrerPreferencesFiltresRapport(tableFiltres);
        });
        $('#button-nouvelle-preferences-filtres-rapport').on('click', function(e){
            let nom_preference = $('#nom-nouvelle-preferences-filtres-rapport').val();
            if(!nom_preference){
                alert('Un nom de préférence est requis avant d\'enregistrer.');
                return;
            }
            enregistrerPreferencesFiltresRapport(tableFiltres, nom_preference);
        });
    };
    fenetreModal.creerModal(paramsModals, customParams, [callback_modaleEnregistrerPreferencesFiltresRapport]);
}

function modaleGererPreferencesFiltresRapport(tableFiltres){
    var tableElem = tableFiltres.data('table-elem');
    let id_rapport = tableElem.data('id-rapport');
    let paramsModals = {
        id: 'modale-gerer-preferences-filtres-rapport',
        titre:'Gérer vos préférences filtres rapports',
        view: "/core/modal/",
        template_view: "/gestion-roles/modale-gerer-preferences-filtres-rapport/",
        taille: "grande"
    };
    let customParams = {
        rapport_id: id_rapport,
        id_evenement_type: ''
    };
    var callback_modaleGererPreferencesFiltresRapport = function(){
        $('.button-supprimer-preferences-filtres-rapport').on('click', function(e){
            let nom_preference = $(this).parent().find('.nom_preferences').text();
            if (confirm("Êtes-vous sur de vouloir supprimer cette préférence?") == true) {
                supprimer_preference_filtres_rapport($(this), id_rapport, nom_preference);
            }
        });
        $('.button-renommer-preferences-filtres-rapport').on('click', function(e){
            let nom_preference = $(this).parent().find('.nom_preferences').text();
            renommer_preference_filtres_rapport($(this), id_rapport, nom_preference);
        });
    };
    fenetreModal.creerModal(paramsModals, customParams, [callback_modaleGererPreferencesFiltresRapport]);
}

function supprimer_preference_filtres_rapport(button_action, id_rapport, nom_preference){
    renommer_supprimer_preference_filtres_rapport('supprimer', id_rapport, nom_preference);
    $(button_action).parent().remove();
}

function renommer_supprimer_preference_filtres_rapport(action, id_rapport, nom_preference='', nouveau_nom=''){
    var params = {
        action: action,
        id_rapport: id_rapport,
        nom_preference: nom_preference,
        nouveau_nom: nouveau_nom
    };
    $.ajax({
        type: 'POST',
        url: '/gestion-roles/renommer-supprimer-preferences-filtres-rapport/',
        data: params,
        dataType: 'json',
        success: function (response) {
            refresh_liste_boutonsChargerFiltres();
        }
    });
}

function renommer_preference_filtres_rapport(button_action, id_rapport, nom_preference) {
    $('#modale-editer-preferences-filtres-rapport').hide();
    $('#nom-nouvelle-preferences-filtres-rapport').val(nom_preference);
    $('#editer-preferences-input-div').show();
    $('#button-renommer-preferences-filtres-rapport').off('click').on('click', function(e){
        let nouveau_nom = $('#nom-nouvelle-preferences-filtres-rapport').val();
        renommer_supprimer_preference_filtres_rapport('renommer', id_rapport, nom_preference, nouveau_nom);
        $('#modale-editer-preferences-filtres-rapport').show();
        $('#editer-preferences-input-div').hide();
        $(button_action).parent().find('.nom_preferences').html($('#nom-nouvelle-preferences-filtres-rapport').val());
    });
    $('#button-annuler-renommer-preferences-filtres-rapport').off('click').on('click', function(e){
        $('#modale-editer-preferences-filtres-rapport').show();
        $('#editer-preferences-input-div').hide();
    });
}
var last_tableFiltres;
function dessineBoutonsActionFiltresRecherche(tableFiltres, callback_filtre_appliquer) {
    last_tableFiltres = tableFiltres;

    var panneauFiltreActions = tableFiltres.closest('.filtre-panneau').find('.filtres-actions');


    controlesFormulaires.clearable();

    // Filtres - Appliquer les filtres et recharger les résultats de recherche.
    panneauFiltreActions.find('.appliquer-filtre').on("click", function (a) {
        callback_filtre_appliquer(a);
    });

    var boutonEnregistrerFiltres = panneauFiltreActions.find('[name=enregistrer-filtre]');
    boutonEnregistrerFiltres.on("click", function () {
        modaleEnregistrerPreferencesFiltresRapport(tableFiltres);
    });


    var boutonGererFiltres = panneauFiltreActions.find('[name=gerer-filtre]');
    boutonGererFiltres.on("click", function () {
        modaleGererPreferencesFiltresRapport(tableFiltres);
    });
    load_action_boutonsChargerFiltres();

}

function load_action_boutonsChargerFiltres(){
    // apellée à l'initialisation d'un rapport ayant des filtres;
    // et lorsque on altère des filtres, pour recharger leur liste de sélection.
    let panneauFiltreActions = last_tableFiltres.closest('.filtre-panneau').find('.filtres-actions');
    var boutonsChargerFiltres = panneauFiltreActions.find('[name=charger-filtre]');
    boutonsChargerFiltres.off('click').on('click', function(e){
        let nom_preference = $(this).find('a').text();
        chargerPreferencesFiltresRapport(nom_preference);
    });
}

function refresh_liste_boutonsChargerFiltres(){
    var params = {
        id_rapport: last_tableFiltres.data('table-elem').data('id-rapport'),
    };
    $.ajax({
        type: 'POST',
        url: '/gestion-roles/liste-preferences-filtres-rapport/',
        data: params,
        dataType: 'json',
        success: function (response) {
            $('#include_liste_preferences_filtres_rapport')[0].outerHTML=response.html;
            load_action_boutonsChargerFiltres();
        }
    });
}

function chargerTagsFiltresRecherche(tableFiltres, champsDynamiques) {
    for (var i = 0; i < champsDynamiques.length; i++) {
        var champs = champsDynamiques[i];
        var divChampDynamique = tableFiltres.find('td.filtres[name=' + champs.nom + '] > div[name=' + champs.nom + ']');

        var champDynamique = divChampDynamique.find('[name=' + champs.nom + ']');

        champDynamique.select2({
            width: champs.taille,
            dropdownAutoWidth: 'true'
        });
    }
}

// pour l'instant sert de recharge suite à un cascading
function rechargerFiltre(tableFiltres, champsDynamiques) {
    var url = "/gestion-roles/rapports/recharger-filtre/";

    var tableElem = tableFiltres.data('table-elem');

    buildFiltresSelectionContenu(tableElem);

    let filtres = tableElem.data('filtres');
    if (filtres) {
        filtres = epurerListeFiltresPost(filtres);
    }

    for (var i = 0; i < champsDynamiques.length; i++) {
        var champs = champsDynamiques[i];

        var params = {
            id_rapport: tableElem.data('id-rapport'),
            nom: champs.nom
        };

        if (filtres) {
            params['filtres'] = JSON.stringify(filtres);
        }

        $.ajax({
            type: "GET",
            async: false, // nécessaire sinon, la boucle se termine avant l'exécution du call ajax : écrase le dernier champ utilisé.
            url: url,
            data: params,
            dataType: 'html',
            success: function (response) {
                var divChampDynamique = tableFiltres.find('td.filtres[name=' + champs.nom + ']');
                divChampDynamique.replaceWith(response);

                divChampDynamique = tableFiltres.find('td.filtres[name=' + champs.nom + ']');
                var champDynamique = divChampDynamique.find('.filtre-select[name=' + champs.nom + ']');

                masquesSelection.init();
                champDynamique.select2({
                    width: champs.taille,
                    dropdownAutoWidth: 'true'
                });

            }
        });
    }
}


function chargerPreferencesFiltresRapport(nom_preference){
    // vient définir la "derniere préférence" (last)
    // et recharger le rapport
    wait.start();
    var tableElem = last_tableFiltres.data('table-elem');
    var params = {
        id_rapport: tableElem.data('id-rapport'),
        nom_preference: nom_preference
    };
    $.ajax({
        type: 'POST',
        url: '/gestion-roles/charger-preferences-filtres-rapport/',
        data: params,
        dataType: 'json',
        success: function (response) {
            wait.stop();
            // recharge le module,
            //  pour recréer la page de rapport et charger les dernières préférences
            $(window.evb_last_module).click();
        }
    });
}
function enregistrerPreferencesFiltresRapport(tableFiltres, nom_preference='') {
    var tableElem = tableFiltres.data('table-elem');
    buildFiltresSelectionContenu(tableElem);
    var params = {
        id_rapport: tableElem.data('id-rapport'),
        nom_preference: nom_preference
    };
    let filtres = tableElem.data('filtres');
    if (filtres) {
        filtres = epurerListeFiltresPost(filtres);
        params['filtres'] = JSON.stringify(filtres);
    }
    wait.start();
    $.ajax({
        type: 'POST',
        url: '/gestion-roles/enregistrer-preferences-filtres-rapport/',
        data: params,
        dataType: 'json',
        success: function (response) {
            wait.stop();
            infos.ajouterMessageToast({
                message: "Enregistrement des filtres réussi",
                messageDuree: 1500,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
            refresh_liste_boutonsChargerFiltres();
        }
    });
    fenetreModal.fermerModal();
    wait.stop();
}

function initSelectDependant(tableFiltres, filtresInit) {
    var listeDependances = tableFiltres.find('[data-dependant_de]'); // On liste les input et select qui présentent des dépendances de sélection ou d'activation.
    $.each(listeDependances, function (key, value) {
        // pour chaque dépendance, on crée l'event de gestion de la sélection.
        var parentNom = $(value).attr('data-dependant_de');

        var selectDependantChanged = function () {
            // Lancer l'appel Ajax pour récupérer les données...
            var champEnfantNom = $(value).closest('td.filtres').attr('name');

            buildFiltresSelectionContenu(tableFiltres.data('tableElem'));

            var longueurFiltres = filtresInit.champs[parentNom].filtres;
            var selection = [];
            $.each(longueurFiltres, function (index, valeur) {
                selection.push(valeur.id);
            });

            var filtres = filtresInit.champs[champEnfantNom];

            var champsDynamiques = [];
            champsDynamiques.push({
                "nom": champEnfantNom,
                "dependant_de_valeur": JSON.stringify(selection),
                "taille": filtres.parametres[0].taille
            });

            rechargerFiltre(tableFiltres, champsDynamiques);
            // TODO vérifier si c'est générique
            var selectEnfant = tableFiltres.find('select.filtre-select[name="' + champEnfantNom + '"]');
            selectEnfant.on('change', function (a) {
                initialiserBoutonFiltre(filtresInit, tableFiltres, a);
            });

            selectEnfant.trigger('change'); // exemple si on vient de rafraichir "lot" ici, ce trigger va permettre de rafraichir les sous-enfants donc "sous-lot"
        };

        //parentInput.off('change', selectDependantChanged).on('change', selectDependantChanged);
        var selecteur = 'select[name="' + parentNom + '"]';
        tableFiltres.off('change', selecteur, selectDependantChanged).on('change', selecteur, selectDependantChanged);
    });
}

function ajouteSousFiltreRecherche(listeFiltres, tableFiltres, nomChamp, valeur, titre, etat) {

    var id = valeur;
    var index;

    var m_listeFiltres = listeFiltres;
    var filtre = m_listeFiltres.champs[nomChamp];

    if (filtre.parametres[0].form !== "input") {
        if (filtre.parametres[0].form === "date") {
            if (titre.length > 10) {
                var range = regEx.decomposeDateRange(titre);
                filtre.filtres[0].debut = range[0];
                filtre.filtres[0].fin = range[1];
            } else {
                filtre.filtres[0].debut = titre;
                filtre.filtres[0].fin = "";
            }
        } else {
            /*index = -1;
            for (var i = 0; i < (filtre.filtres).length; i++) {
                if (id == filtre.filtres[i].id) {
                    index = i;
                }
            }
            if (index < 0) {
                index = filtre.filtres.length;
                filtre.filtres.push({
                    "nom": titre,
                    "id": id,
                    "etat": etat,
                    "contenu": ""
                });
            }*/

            var boutons = tableFiltres.find('.filtres[name=' + nomChamp + '] .selected_options > div');
            var boutonSelection = null;
            boutons.each(function () {
                var boutonId = $(this).find('> .filtre:not(.filtre-close)').attr('value');
                if (boutonId == id) {
                    boutonSelection = $(this);
                }
            });

            if (boutonSelection) {
                return;
            }
        }
    }


    var colonne = nomChamp;
    var html = '';
    var etatBouton = (etat === "Inactif") ? 'btn-light' : 'btn-success';
    var effacable = filtre.parametres[0].form != 'button';
    var choix_actif = (filtre.parametres[0].bool_choix_actif_seulement) ? 'disabled-filtre' : '' ;
    if (filtre.parametres[0].buttons === "oui" /*&& filtre.parametres.length > 0*/) {
        //html += '<div><button value="' + filtre.filtres[index].id + '" filtre="' + filtre.parametres[0].titre + '" class="filtre btn btn-sm ' + etatBouton + '" title="' + (etatBouton == "gel" ? "" : "Cliquez pour activer (2 états) ou désactiver ce filtre") + '">' + filtre.filtres[index].nom + '</button><button value="' + filtre.filtres[index].id + '-effacer" class="filtre-close btn btn-sm ' + etatBouton + ' filtre" title="Effacer ce filtre"><i class="fa ' + (!effacable ? "fa-lock" : "fa-times") + '"></i></button></div>';
        html += '<div><button value="' + id + '" class="filtre btn btn-sm ' + etatBouton + ' ' + choix_actif + '" title="' + (etatBouton == "gel" || choix_actif !='' ? "" : "Cliquez pour activer (2 états) ou désactiver ce filtre") + '">' + titre + '</button><button value="' + id + '-effacer" class="filtre-close btn btn-sm ' + etatBouton + ' filtre" title="Effacer ce filtre"><i class="fa ' + (!effacable ? "fa-lock" : "fa-times") + '"></i></button></div>';
    } else {
        if (filtre.parametres[0].form === "text") {
            html += '<input type="text" class="col-xs-12" id="' + colonne + '-' + champ + '-text" disabled value="' + filtre.filtres[index].nom + '">';
        }
    }

    var inputChamp = tableFiltres.find('td.filtres[name="' + colonne + '"]').find('input.filtre-input,div.select2-container.filtre-input,div.select2-container.filtre-select');

    var formType = filtre.parametres[0].form;
    switch (formType) {
        case "select":
            tableFiltres.find('.filtres[name='+nomChamp+'] .selected_options').append(html);
            tableFiltres.find('.filtres[name='+nomChamp+'] .select2-container.filtre-select.filtre-input').css('display', filtre.parametres[0].bool_choix_actif_seulement ? 'none' : 'block');
            break;
        case "input": case "date":
            inputChamp.val("");
            tableFiltres.find('.filtres[name='+nomChamp+'] .selected_options').append(html);
            break;
    }

}

function initEventFiltres(listeFiltres, tableFiltres) {
    //init_dateRangePicker();
    var idRapportGroupe = $('[name=hid-id-rapport-groupe]').val();
    var idRapport = 0;
    if(idRapportGroupe !== undefined ) {
        var arrNom = $('.tabbable').find('li.active > a').attr('id').split('-');
        idRapport = arrNom[2];
    }
    var indicerapport =  (idRapport !== 0) ? '-' + idRapport :'';
    // Filtre auto selection sur Extracteur unite Evaluation
    var boutons = tableFiltres.find('.filtres[name=bool_evenement_ouvert] .selected_options > div');
        boutons.each(function() {
            if ($(this).find('> .filtre:not(.filtre-close)').hasClass('disabled-filtre')) {
                $(this).parent().parent().find('.select2-container.filtre-select.filtre-input').css('display', 'None');
            }
        });

    // Filtres - Modification de l'état du bouton "Appliquer les filtres" lorsqu'un champ select est modifié (ajout ou non de bouton).
    tableFiltres.find('select.filtre-select').on('change', function (a) {
        initialiserBoutonFiltre(listeFiltres, tableFiltres, a);
        filtresEvenements.toggleBoutonAppliquerFiltreRecherche('#appliquer-filtre'+indicerapport+'', 'Actif');
    });

    // Filtres - Activer ou désactiver.
    tableFiltres.on("click", "button.filtre", function () {
        var elemFiltre = $(this).closest('div').find('.filtre:not(.filtre-close)');
        var select = elemFiltre.closest('td.filtres').find('select.filtre-select');

        if ($(this).hasClass('filtre-close')) {
            if ($(this).find('i').hasClass('fa-lock') || $(this).hasClass('fa-lock')) {
                toggleFiltreRecherche(listeFiltres, elemFiltre);
            } else {
                detruitFiltreRecherche(listeFiltres, elemFiltre);
                if (elemFiltre.hasClass('disabled-filtre'))
                {
                    select.parent().find('.select2-container.filtre-select.filtre-input').css('display', 'block');
                }
               select.trigger('change');

            }
        } else {
            if (!elemFiltre.hasClass('disabled-filtre')) {
                toggleFiltreRecherche(listeFiltres, elemFiltre);
            }
        }
    }); // Delegated Event

    // Filtres - Modification de l'état du bouton "Appliquer les filtres" lorsqu'un champ input est modifié.
    tableFiltres.find('input').not('[name=date-range-picker]').on('change', function (a) { // On peuple filtres. Utilisé pour stocker la valeur des champs input qui n'ont pas de filtres ou dont on n'utilise pas le "Enter (keypress 13)" pour ajouter un bouton de filtre.
        var input = $(a.target);
        var selection = input.attr('name');
        var selectionText = a.target.value;
        var filtreChamp = listeFiltres.champs[selection];

        try {
            filtreChamp.parametres[0].contenu = selectionText;
        } catch (e) {
        }

        if (input.attr('est-plage') != null) {
            var debut = selectionText;
            var fin = selectionText;
            var idx = debut.indexOf('-');

            if (idx > -1) {
                fin = debut.substring(idx + 1);
                debut = debut.substring(0, idx);
            }

            if (filtreChamp.filtres.length == 0) {
                filtreChamp.filtres.push({});
            }

            filtreChamp.filtres[0].debut = debut;
            filtreChamp.filtres[0].fin = fin;
        }

    });

    // Filtres - Modification de l'état du bouton "Appliquer les filtres" lorsqu'un champ input est modifié.
    tableFiltres.find('input[name=date-range-picker]').on('change', function (a) { // On peuple filtres. Utilisé pour stocker la valeur des champs input qui n'ont pas de filtres ou dont on n'utilise pas le "Enter (keypress 13)" pour ajouter un bouton de filtre.
        modifierDonneesDateRangePicker(listeFiltres, a);
    });


    tableFiltres.find('input[name=date-range-picker]').on('apply.daterangepicker', function (a) { // ev, picker peuvent être des paramètres supplémentaires
        modifierDonneesDateRangePicker(listeFiltres, a);
    });

    tableFiltres.find('input').on('keypress', function (a) {
        if (a.which == 13) { // "Enter (keypress 13)"
            var input = $(a.target);
            var filtreTd = input.closest('td.filtres');
            var nom = filtreTd.attr('name');
            //var selection = input.attr('name');
            var filtreChamp = listeFiltres.champs[nom];

            if (/*filtreChamp.parametres[0].form_add_to_page === 'oui' && */filtreChamp.parametres[0].buttons === 'oui') {
                // var selection = a.target.id + '-' + a.target.id + '-' + 'input';
                var selectionText = a.target.value;
                //var resultat = regEx.decomposeIdFiltre(selection, "-");
                //resultat[2] = a.target.value;
                /*$('#' + a.target.id)*/
                $(a.target)[controlesFormulaires.toggleAddRemoveClass(this.value)]('x');
                //var m_listeFiltres = filtresEvenements.reqListeFiltres();
                var etat = "Actif";
                ajouteSousFiltreRecherche(listeFiltres, tableFiltres, filtreChamp.parametres[0].nom, a.target.value, selectionText, etat);
                $(this).focusout();
                $(this).focus();
            }
        }
    });

}

function detruitFiltreRecherche(listeFiltres, elemFiltre) {
    var elemDel = elemFiltre.closest('div').find('.filtre.filtre-close');

    try {
        elemDel.parent().remove();
    } catch (e) {
        alert(e);
    }
    return false;
}


function toggleFiltreRecherche(listeFiltres, elemFiltre) {
    var elemDel = elemFiltre.closest('div').find('.filtre.filtre-close');
    var activeInclude = 'btn-success';
    var activeExclude = 'btn-danger';
    var inactive = 'btn-light';

    if (elemFiltre.hasClass(inactive)) {
        elemFiltre.removeClass(inactive).addClass(activeInclude);
        elemDel.removeClass(inactive).addClass(activeInclude);
    } else if (elemFiltre.hasClass(activeInclude)) {
        elemFiltre.removeClass(activeInclude).addClass(activeExclude);
        elemDel.removeClass(activeInclude).addClass(activeExclude);
    } else if (elemFiltre.hasClass(activeExclude)) {
        elemFiltre.removeClass(activeExclude).addClass(inactive);
        elemDel.removeClass(activeExclude).addClass(inactive);
    }

    return false;
}


function modifierDonneesDateRangePicker(listeFiltres, a) {
    var input = $(a.target);
    input[controlesFormulaires.toggleAddRemoveClass(a.target.value)]('x');
}

function getFiltreValeurs(tableElem, nomFiltre) {
    var retour = [];

    var listeFiltres = tableElem.data('filtres');
    var filtreChamp = listeFiltres.champs[nomFiltre];
    for (var filtre in filtreChamp.filtres) {
        var element = jQuery.extend(true, {}, filtreChamp.filtres[filtre]); // copier l'élément au lieu de référencer
        retour.push(element);
    }

    return retour;
}

function setFiltreValeurs(tableElem, nomFiltre, filtres) {
    var tableFiltres = tableElem.data('table-filtres');
    var divFiltre = tableFiltres.find('[name=' + nomFiltre + ']');
    var tdFiltre = divFiltre.closest('td.filtres');
    var delBoutons = tdFiltre.find('button.filtre-close');
    delBoutons.click();

    for (var idx in filtres) {
        var filtre = filtres[idx];
        var id = filtre.id;
        var etatBouton = (filtre.etat === "Inactif") ? 'btn-light' : filtre.etat === "gel" ? 'btn-primary' : filtre.etat === "ActifExclusif" ? 'btn-danger' : 'btn-success';

        var selectElem = tableFiltres.find('[name=' + nomFiltre + '] select.filtre-select');
        if (selectElem.length) {
            selectElem.select2("val", id);
            selectElem.trigger('change');
            var simpleBoutons = tdFiltre.find('button.filtre');
            simpleBoutons.removeClass('btn-success').addClass(etatBouton);
        }
         else {
             var textElem = tableFiltres.find('input[name=' + nomFiltre + ']');
             textElem.val(id).trigger('change');
             var e = jQuery.Event("keypress");
             e.which = 13; //choose the one you want
             e.keyCode = 13;
             textElem.trigger(e);
         }

    }

}

// rafraichir les .filtres et .contenu
function buildFiltresSelectionContenu(tableElem) {
    var tableFiltres = tableElem.data('table-filtres');
    var filtres = tableElem.data('filtres');

    $.each(filtres.champs, function(nom, filtre) {
        var formType = filtre.parametres[0].form;
        if (formType === 'select' || formType === 'input' || formType === 'button') {
            filtre.filtres.length = 0;

            var boutons = tableFiltres.find('.filtres[name='+nom+'] .selected_options > div');

            boutons.each(function() {
                var boutonFiltre = $(this).find('> .filtre:not(.filtre-close)');
                var id;
                var etat;
                if (filtre.parametres[0].form_type === 'int'){
                    id = parseInt(boutonFiltre.attr('value'));
                } else {
                    id = boutonFiltre.attr('value');
                }

                var titre = boutonFiltre.text();

                if (boutonFiltre.is('.btn-danger')) {
                    etat = 'ActifExclusif';
                }
                if (boutonFiltre.is('.btn-success')) {
                    etat = 'Actif';
                }
                if (boutonFiltre.is('.btn-light')) {
                    etat = 'Inactif';
                }

                filtre.filtres.push({
                    "nom": titre,
                    "id": id,
                    "etat": etat,
                    "contenu": ""
                });

            });

        }
        var input;

        if (formType === 'input') {
            input = tableFiltres.find('.filtres[name='+nom+'] input.filtre-input');
            if (filtre.parametres[0].form_type === 'int'){
                filtre.parametres[0].contenu = parseInt(input.val());
            } else {
                filtre.parametres[0].contenu = input.val();
            }

        } else if (formType === 'date') {
            input = tableFiltres.find('.filtres[name='+nom+'] input.filtre-input');

            var selection = input.closest('div.filtres').attr('name'); // a.target.id;
            var selectionText = input.val();
            var filtreChamp = filtres.champs[selection];
            var debut = '';
            var fin = '';

            if (filtreChamp.filtres.length === 0) {
                filtreChamp.filtres.push({});
            }
            if (selectionText && selectionText.length > 10) {
                var dates = regEx.decomposeDateRange(selectionText); // split les dates.
                debut = dates[0];
                fin = dates[1];
            }
            filtreChamp.filtres[0].nom = nom;
            filtreChamp.filtres[0].debut = debut;
            filtreChamp.filtres[0].fin = fin;
            filtreChamp.filtres[0].contenu = selectionText;

        } else if (formType === 'range') {
            var input_debut = tableFiltres.find('.filtres[name=' + nom + '] input.filtre-input[name=' + nom + '_debut]');
            var input_fin = tableFiltres.find('.filtres[name=' + nom + '] input.filtre-input[name=' + nom + '_fin]');
            filtreChamp = filtres.champs[nom];
            if (filtreChamp.filtres.length === 0) {
                filtreChamp.filtres.push({});
            }
            filtreChamp.filtres[0].nom = nom;
            filtreChamp.filtres[0].debut = input_debut.val();
            filtreChamp.filtres[0].fin = input_fin.val();
        }
    });
}

function mergeFiltresAvecJson(filtres, filtresDefJson) {
    var listeFiltresBase = $.extend(true, {}, filtres.champs);
    filtres.champs = {};

    var filtresDef = JSON.parse(filtresDefJson);
    for (var i = 0; i < filtresDef.length; i++) {
        var nouvelObjet = {};

        nouvelObjet[filtresDef[i].nom] = {
            parametres: [{}],
            filtres: []
        };
        if (typeof (listeFiltresBase[filtresDef[i].nom]) != 'undefined') {
            nouvelObjet[filtresDef[i].nom] = listeFiltresBase[filtresDef[i].nom];
        }

        for (var property in filtresDef[i]) {
            if (filtresDef[i].hasOwnProperty(property)) {
                nouvelObjet[filtresDef[i].nom].parametres[0][property] = filtresDef[i][property];
            }
        }

        $.extend(true, filtres.champs, nouvelObjet);
    }
}
